import React from "react";

import ClusterScore from "evaluation/ClusterScore";
import CompetenceScore from "evaluation/CompetenceScore";

import {
	Cluster,
	Competence,
	Criteria,
	CriteriaType
} from "trajectory/TrajectoryService";
import { Filtered } from "./EvaluationUtils";

type MapType = {
	all: boolean;
};

export interface CriteriaScoreProps {
	depth?: number;
	index: number;
	filtered: Filtered[];
	disabled: boolean;
	criteria: Criteria;
	minScore: number;
	maxScore: number;
	editDate: Date | null;
	showFields: boolean;
	expanded: MapType;
	getScoreName: (score: number | null) => string;
	getScoreInfo: (score: number | null) => string;
	getScoreColour: (score: number | null) => string;
}

export type UpdateCompetenceAction = {
	index: number;
	criterion: Criteria;
};

export type UpdateClusterAction = {
	index: number;
	criterion: Cluster;
};

const CriteriaScore: React.FC<CriteriaScoreProps> = (
	props: CriteriaScoreProps
) => {
	switch (props.criteria.type) {
		case CriteriaType.CLUSTER: {
			const cluster = props.criteria as Cluster;
			return (
				<ClusterScore
					{...props}
					depth={props.depth ?? 0}
					criteria={cluster}
				/>
			);
		}
		case CriteriaType.COMPETENCE: {
			const competence = props.criteria as Competence;
			return (
				<CompetenceScore
					{...props}
					depth={props.depth ?? 0}
					criteria={competence}
				/>
			);
		}
		default: {
			return <></>;
		}
	}
};

export default CriteriaScore;
